import { getErrorInltBuilder } from "@krakentech/error-intl"

const createErrorIntl = getErrorInltBuilder<IntlMessages>()

export const { formatServerSideRequestError, useFormatRequestError, useFormatErrorCode } =
    createErrorIntl({
        namespace: "errorIntl",
        formatErrorCode({ t, errorCode }) {
            return t("errorMessage", { errorCode: errorCode.replaceAll("-", "_") })
        },
        async getMessages(_locale) {
            return import(`messages/fr.json`)
        },
    })
